var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Repost",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-repost","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M130.9 232c-30.6-.4-61-15.9-90.5-46.3l20.8-20.6c26.6 27.4 52.9 39.9 78.2 37.1 41.3-4.6 68.8-48.5 69.1-49l24.8 15.4c-1.4 2.3-34.9 56.5-90.5 62.8-3.9.4-7.9.6-11.9.6z" className="st0"/>
  <path d="M44.1 79.9l-25-15.2C20.5 62.3 54.4 6.8 110.2.5c34.5-3.9 68.6 11.6 101.5 46.1l-21 20.4c-26.3-27.6-52.3-40.1-77.3-37.3C92 32.1 74.3 45.5 63.3 56.3c-12.1 12-19.2 23.5-19.2 23.6z" className="st0"/>
  <polygon points="104,142.2 1.6,79.8 5,210.2" className="st0"/>
  <polygon points="148.1,90.8 250,153.8 247.1,21.3" className="st0"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/repost.svg